import { useContext, useEffect, useMemo, useState } from "react";
import ModuleCard from "../../components/ModuleCard/ModuleCard";
import { IFavoritesProps } from "./Favorites.interface";
import { TranslationContext } from "../../shared/providers/translation/translation.provider";
import { ModuleContext } from "../../shared/providers/module/module.provider";
import { IModule } from "../../shared/interfaces/modules.interface";
import NotFound from "./../../shared/assets/imgs/not_found.svg";
import { LoadingContext } from "../../shared/providers/loading/loading.provider";

function Favorites(props: IFavoritesProps) {
    const [favorites, setFavorites] = useState<IModule[]>([]);
    const { setIsLoading } = useContext(LoadingContext);
    const { translate } = useContext(TranslationContext);
    const { modules } = useContext(ModuleContext);
    const hasModules = useMemo(() => favorites && !!favorites.length, [favorites]);

    useEffect(() => {
        setIsLoading(true);
    }, []);

    useEffect(() => {
        if (modules) {
            setFavorites(modules.filter((mod) => mod.isFavorite));
            setIsLoading(false);
        }
    }, [modules]);

    return (
        <div className="px-1 px-md-31 pb-22 d-flex flex-column align-items-start justify-content-start h-100">
            {hasModules && (
                <>
                    <h1 id="title" className="text-h3-smbd pb-1">
                        {translate("common.favorites", "Favorites")}
                    </h1>
                    <section className="col-12" aria-labelledby="title">
                        <div className="row g-1">
                            {favorites?.map((module) => (
                                <div className="col-12 col-md-6 col-lg-3" key={module.id}>
                                    <ModuleCard
                                        {...module}
                                        title={module.title}
                                        contentAmount={module.contentAmount}
                                        description={module.description}
                                    />
                                </div>
                            ))}
                        </div>
                    </section>
                </>
            )}
            {!hasModules && (
                <div className="row g-1 h-100 mt-n33 mt-md-0">
                    <div className="col-12 h-100 d-flex flex-column justify-content-start align-items-center align-items-md-start gap-12">
                        <img src={NotFound} aria-hidden="true" alt="" width={225} />
                        <h1 className="text-h1-smbd">
                            {translate("favorites.no_favorites_title", "No favourites yet!")}
                        </h1>
                        <p className="m-0 color-neutrals-dark text-bd1-rg text-center text-md-start">
                            {translate(
                                "favorites.no_favorites_description",
                                "Tap on the heart to add to your favourites! See them here at a glance."
                            )}
                        </p>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Favorites;
